import { useRouter } from "next/router";
import { DEFAULT_LOCALE, Locale } from "../locales";

const useLocale = (): Locale => {
  const { locale } = useRouter();
  return (Locale.is(locale) ? locale : DEFAULT_LOCALE) as Locale;
};

export default useLocale;
